import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_QuarterlyHomeVisits = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_QuarterlyHomeVisits' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Quarterly Home Visits</h3></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Individual:</span>
                            <input type='text' name='txtIndividual' id='txtIndividual' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date:</span>
                            <input type='date' name='txtDate' id='txtDate' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Daily Service Notes</span>
                    <textarea id='txtDailyService' name='txtDailyService' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Review of Meals & Meal Plans</span>
                    <textarea id='txtDailyService1' name='txtDailyService1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Food Availability</span>
                    <textarea id='txtDailyService2' name='txtDailyService2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Review of Purchasing</span>
                    <textarea id='txtDailyService3' name='txtDailyService3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Review of Individual's Finances and Budgeting</span>
                    <textarea id='txtDailyService4' name='txtDailyService4' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Individual's Satisfaction/Suggestions</span>
                    <textarea id='txtDailyService5' name='txtDailyService5' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-450'>
                        </td>
                        <td className='signature w-250'>
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-450'>Individual/Legal Representative
                        </td>
                        <td className='small w-250'>Date:
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-450'>
                        </td>
                        <td className='signature w-250'>
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-450'>Employee Signature
                        </td>
                        <td className='small w-250'>Date:
                        </td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











